import React from 'react';
import { FlagIcon } from './FlagIcon';

export const FlagRO = props => (
    <FlagIcon {...props} viewBox="0 0 512 512">
        <rect width="170.67" height="512" fill="#002B7F" />
        <rect width="170.67" height="512" x="170.67" fill="#FCD116" />
        <rect width="170.67" height="512" x="341.33" fill="#CE1126" />
    </FlagIcon>
);
